export enum BusinessDevelopmentPermissions {
  ChBussDevelopment = "ChBussDevelopment",
  ChSalesManagement = "ChSalesManagement",
  ChBusinessReports = "ChBusinessReports",
  ChAccessAllUsersSales = "ChAccessAllUsersSales",
  ChAccessAllProducersSales = "ChAccessAllProducersSales",
  ChAccessAllBranchBussiness = "ChAccessAllBranchBussiness",
  ChBusinessDevelopmentReadOnly = "ChBusinessDevelopmentReadOnly",

  ChSalesforceSupport = "ChSalesforceSupport",
  ChProspectRegistry = "ChProspectRegistry",
  ChUnderwritingDepartment = "ChUnderwritingDepartment",
  CHPandingSalesLead = "CHPandingSalesLead",
  CHExpiredLeadsPolices = "CHExpiredLeadsPolices",
}
